/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_TitleInputs */

const en_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Image and Print-on-Demand Automation`)
};

const ar_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أتمتة صور الذكاء الاصطناعي والطباعة عند الطلب`)
};

const bn_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এআই ছবি ও প্রিন্ট-অন-ডিমান্ড অটোমেশন`)
};

const de_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Bild- und Print-on-Demand-Automatisierung`)
};

const es_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatización de imágenes IA y print-on-demand`)
};

const fr_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisation d'images IA et de print-on-demand`)
};

const pt_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automação de imagens IA e print-on-demand`)
};

const zh_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 图片与按需打印自动化`)
};

const tr_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YZ Görsel ve Print-on-Demand Otomasyonu`)
};

const ru_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-картинки и автоматизация print-on-demand`)
};

const pl_svc_ai_image_pod_automation_title = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatyzacja obrazów AI i print-on-demand`)
};

/**
* | output |
* | --- |
* | "AI Image and Print-on-Demand Automation" |
*
* @param {Svc_Ai_Image_Pod_Automation_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_title = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_title(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_title(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_title(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_title(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_title(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_title(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_title(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_title(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_title(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_title(inputs)
	return en_svc_ai_image_pod_automation_title(inputs)
});
export { svc_ai_image_pod_automation_title as "svc_ai-image-pod-automation_title" }